import { ArrowUp } from "assets/svg";
import { useEffect, useState } from "react";
import { useEventStore } from "store";

export default function ScrollToTopButton() {
  const [isVisible, setIsVisible] = useState(false);
  const { theme } = useEventStore();

  useEffect(() => {
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

    const scrollableElement = isIOS
      ? document.querySelector(".theme-layout") ||
        document.querySelector(".overflow-y-auto")
      : document.querySelector(".overflow-y-auto");

    if (!scrollableElement) return;

    const handleScroll = () => {
      setIsVisible(scrollableElement.scrollTop > 200);
    };

    if (isIOS) {
      const events = ["scroll", "touchend", "touchmove"];

      events.forEach((eventType) => {
        scrollableElement.addEventListener(eventType, handleScroll, {
          passive: true,
        });
      });

      return () => {
        events.forEach((eventType) => {
          scrollableElement.removeEventListener(eventType, handleScroll);
        });
      };
    } else {
      scrollableElement.addEventListener("scroll", handleScroll);
      return () =>
        scrollableElement.removeEventListener("scroll", handleScroll);
    }
  }, []);

  const scrollToTop = () => {
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

    const scrollableElement = isIOS
      ? document.querySelector(".theme-layout") ||
        document.querySelector(".overflow-y-auto")
      : document.querySelector(".overflow-y-auto");

    if (scrollableElement) {
      if (isIOS) {
        const startScrollTop = scrollableElement.scrollTop;
        const duration = 500;
        const startTime = performance.now();

        const animateScroll = (currentTime: number) => {
          const elapsed = currentTime - startTime;
          const progress = Math.min(elapsed / duration, 1);
          const easeOut = 1 - Math.pow(1 - progress, 3);
          const currentScrollTop = startScrollTop * (1 - easeOut);

          scrollableElement.scrollTop = currentScrollTop;

          if (progress < 1) {
            requestAnimationFrame(animateScroll);
          } else {
            scrollableElement.scrollTop = 0;
          }
        };

        requestAnimationFrame(animateScroll);
      } else {
        scrollableElement.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    }
  };

  return isVisible ? (
    <button
      onClick={scrollToTop}
      className={`${
        theme.name === "rose" ? "bg-primary-rose" : "bg-gray-400"
      } fixed bottom-2 right-2 text-white opacity-70 p-3 rounded-full shadow-lg z-30`}
    >
      <ArrowUp width={24} height={24} color="none" outline="#fff" />
    </button>
  ) : null;
}
